@import 'styles/mixins';
@import 'styles/variables';

.section {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding-bottom: 15px;
  padding-top: 10px;
}

.picker {
  padding: 6px 0;
  display: grid;
  grid-template-columns: repeat(9, minmax(9.5%, 1fr));
  max-width: calc((9 * 35px) + (8 * 5px));
}
